import { useState } from "react";

const useSort = () => {
    const [sort, setSort] = useState({
        key: "",
        type: "",
    });

    const updateSort = (key) => {
        let clonedSort = {...sort };
        let { key: sortKey, type } = clonedSort;

        if (key === sortKey) {
            if (type === "ASC") {
                clonedSort.type = "DESC";
            } else {
                clonedSort.type = "ASC";
            }
        } else {
            clonedSort.key = key;
            clonedSort.type = "ASC";
        }

        setSort(clonedSort);
    };

    return [sort, updateSort];
};

export default useSort;